export default "__VITE_ASSET__BJ83RR15__"